module.exports = __webpack_public_path__ + "assets/media/trending-line.916fdde5.svg";